import React from 'react';
import PageTransition from '@/components/page-transition/PageTransition';
import classes from './data.module.scss';
import Text from '@/components/text/text';
import Hero from '@/components/hero/hero';
import StructuredData from './structured-data';
import Contact from '@/components/contact/contact';
import ContentArea from '@/components/content-area/content-area';
import SplitContent from '@/components/split_content/split_content';
import DataLogo from '@/components/icons/data';

export default function Data() {

  return (
    <>
      <StructuredData />
      <PageTransition>
        <main className={classes.wrapper}>
          <div className={'body-bg'}></div>
          <Hero
            text='small'
            title='Data-Driven Insights for Informed Decision-Making' />
          <ContentArea hero>
            <>
              <DataLogo isActive duration={1} isPrevActive={false} feature />
              <SplitContent>
                <>
                  <Text type={'h5'} column={0}>We&rsquo;re here to empower your business with data and analytics services that provide the insights you need to make informed decisions. </Text>
                  <Text type={'p'} column={0}>Our Data and Analytics services cover a range of essential areas, including but not limited to Google Analytics, Google Tag Manager, and Reporting.</Text>

                </>
              </SplitContent>
            </>
          </ContentArea>
          <ContentArea>
            <>
              <Text type={'h2'} column={0} size='medium'>Google Analytics 4</Text>
              <SplitContent>
                <>
                  <div>
                    <Text type={'p'} column={0}>Our experts will assist you in implementing, configuring, and leveraging this powerful tool to track and measure key metrics. Gain actionable insights into your users, their demographics and behaviours to optimise your digital marketing efforts for maximum impact.</Text>
                  </div>
                </>
              </SplitContent>
            </>
          </ContentArea>
          <ContentArea>
            <>
              <Text type={'h2'} column={0} size='medium'>Google Tag Manager</Text>
              <SplitContent>
                <>
                    <Text type={'p'} column={0}>We&rsquo;ll guide you through the Google Tag Manager, ensuring that your tracking is accurate and your data is comprehensive. With GTM, you can collect valuable data without the need for constant code changes. It&rsquo;s a game-changer for data collection and analytics optimisation.</Text>
                </>
              </SplitContent>
            </>
          </ContentArea>
          <ContentArea>
            <>
              <Text type={'h2'} column={0} size='medium'>Detailed Reporting</Text>
              <SplitContent>
                <>
                    <Text type={'p'} column={0}>Data without analysis is just numbers. We go beyond data collection by providing comprehensive reporting that tells a story. Our reports are designed to help you make sense of your data, understand what&rsquo;s working, and identify areas for improvement.</Text>
                    <Text type={'p'} column={0}>If you have any questions or would like to discuss how our data and analytics services can benefit your business, don&rsquo;t hesitate to reach out to us. Join us, and let&rsquo;s turn your data into a valuable asset.</Text>
                </>
              </SplitContent>
            </>
          </ContentArea>

          <Contact />


        </main>
      </PageTransition>
    </>
  )
}
